export const sodaBiscuits = {
  id: "sodaBiscuits",
  link: "/#/recipes/recipes/sodaBiscuits",
  name: "Soda Biscuits",
  cuisine: "Shin",
  summary: "Drop biscuits, served as a side, especially with misir wat",
  inspiration: "American biscuits",
  quantity: "12 biscuits",
  time: "30 minutes",
  notes:
    "These are pretty standard drop biscuits. Reading that the Shin people were eating drop biscuits threw me for a loop, as I had figured that baking soda wouldn't be available on Roshar at this point due to the technology level. I did eventually find a way to reconcile that, and for a full explanation see the ingredient entry on baking soda.",
  quotes:
    "Bread - or today, soda biscuits - went into the oven. (Wind and Truth ch 36)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/soda-biscuits-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "wheatFlour",
          display: "3 cups all-purpose flour"
        },
        {
          item: "creamOfTartar",
          display: "2 tsp cream of tartar"
        },
        {
          item: "bakingSoda",
          display: "1 tsp baking soda"
        },
        {
          item: "salt",
          display: "1 tsp salt"
        },
        {
          item: "butter",
          display: "3/4 cup butter"
        },
        {
          item: "dairy",
          display: "1 1/4 cup milk"
        }
      ]
    }
  ],
  steps: [
    "Preheat the oven to 450 degrees Fahrenheit. Grease a baking sheet.",
    "In a medium bowl mix together flour, cream of tartar, baking soda and salt. Cut in the butter until the mixture forms small crumbs.",
    "Add the milk all at once and stir just until everything is moistened. Using 2 spoons, scoop a spoonful of dough out of the bowl, then use the second spoon to scrape it off the first spoon and drop it in a heap on the greased baking sheet. Repeat to form 12 piles of dough.",
    "Bake 11 to 13 minutes until golden brown in spots on top."
  ]
}
